module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAzElEQVR4AWOgC/gPAwxpDAyJDEASB8KvIYlYDVDV+k36vHm8DKlANlgwHY+GeIbg6cHl68qZEpkYkxhj5sYAEUMSdg0g1SypLCfvnbTttgWymZKYspdl567IBerEoSGOgS+f78O3D+4T3RliwaYmQ/yD2wbmFOZrz67tv7kfZGosUASkgSWTBZ8ffKf4ArkHbx8Mmx7mPdE7ZVGKSIEIQwqeUEpgcJ/gvuf6nstPL88/Nt+gwYAhiWA8xIPZqRAnEYgHGEoFIpSIG5wAAKn1sga1jRhUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/PK.png
// module id = 1241
// module chunks = 0